const data = [
  {
    ordem: "O12AC1",
    peca: "P112A",
    codigo: "R01",
    descricao: "Injetora01",
    oee: 80,
    desempenho: 90,
    disponibilidade: 87,
    qualidade: 79,
    progress: 1200,
    total: 4000,
    status: "Produção",
    faltante: 2800,
    atraso: -20,
    tempoEstado: "01:20",
    motivoParada: "Injustificada",
    historicoOEE: [77, 100, 90, 88, 86, 70, 80],
    dataHistoricoOEE: [
      "23/04",
      "24/04",
      "25/04",
      "26/04",
      "27/04",
      "28/04",
      "29/04"
    ],
    dateAtual: "10:00",
    indice: 1
  },
  {
    ordem: "O12CC1",
    peca: "P311AC",
    codigo: "T01",
    descricao: "Torno01",
    oee: 79,
    desempenho: 80,
    disponibilidade: 85,
    qualidade: 77,
    progress: 300,
    total: 1000,
    status: "Parada",
    faltante: 700,
    atraso: -10,
    tempoEstado: "01:12",
    motivoParada: "Manutenção",
    historicoOEE: [90, 80, 72, 81, 88, 90, 79],
    dataHistoricoOEE: [
      "23/04",
      "24/04",
      "25/04",
      "26/04",
      "27/04",
      "28/04",
      "29/04"
    ],
    dateAtual: "10:00",
    indice: 2
  },
  {
    ordem: "O12AC2",
    peca: "P0921D",
    codigo: "T02",
    descricao: "Torno02",
    oee: 90,
    desempenho: 80,
    disponibilidade: 100,
    qualidade: 95,
    progress: 100,
    total: 3000,
    status: "Parada",
    faltante: 2900,
    atraso: -200,
    tempoEstado: "02:00",
    motivoParada: "Manutenção Corretiva",
    historicoOEE: [80, 90, 88, 70, 67, 81, 90],
    dataHistoricoOEE: [
      "23/04",
      "24/04",
      "25/04",
      "26/04",
      "27/04",
      "28/04",
      "29/04"
    ],
    dateAtual: "10:00",
    indice: 3
  },
  {
    ordem: "O12AB3",
    peca: "P4412",
    codigo: "R02",
    descricao: "Injetora02",
    oee: 92,
    desempenho: 90,
    disponibilidade: 77,
    qualidade: 98,
    progress: 700,
    total: 2700,
    status: "Setup",
    faltante: 2000,
    atraso: 30,
    tempoEstado: "00:53",
    motivoParada: "Almoço",
    historicoOEE: [88, 91, 86, 72, 79, 80, 92],
    dataHistoricoOEE: [
      "23/04",
      "24/04",
      "25/04",
      "26/04",
      "27/04",
      "28/04",
      "29/04"
    ],
    dateAtual: "10:00",
    indice: 4
  },
  {
    ordem: "O12AAA",
    peca: "P1CC31",
    codigo: "F01",
    descricao: "Fresadora01",
    oee: 88,
    desempenho: 90,
    disponibilidade: 92,
    qualidade: 70,
    progress: 1000,
    total: 2000,
    status: "Parada",
    faltante: 1000,
    atraso: 30,
    tempoEstado: "01:23",
    motivoParada: "Manutenção Corretiva",
    historicoOEE: [90, 91, 86, 78, 79, 81, 88],
    dataHistoricoOEE: [
      "23/04",
      "24/04",
      "25/04",
      "26/04",
      "27/04",
      "28/04",
      "29/04"
    ],
    dateAtual: "10:00",
    indice: 5
  },
  {
    ordem: "O13ACCC",
    peca: "P1092G",
    codigo: "R03",
    descricao: "Rosqueadora03",
    oee: 95,
    desempenho: 91,
    disponibilidade: 100,
    qualidade: 95,
    progress: 1900,
    total: 3000,
    status: "Setup",
    faltante: 1100,
    atraso: -30,
    tempoEstado: "00:20",
    motivoParada: "Manutentor na Máquina",
    historicoOEE: [80, 85, 86, 90, 79, 88, 95],
    dataHistoricoOEE: [
      "23/04",
      "24/04",
      "25/04",
      "26/04",
      "27/04",
      "28/04",
      "29/04"
    ],
    dateAtual: "10:00",
    indice: 6
  },
  {
    ordem: "O991AC",
    peca: "P9299",
    codigo: "F02",
    descricao: "Fresadora02",
    oee: 83,
    desempenho: 90,
    disponibilidade: 88,
    qualidade: 80,
    progress: 2900,
    total: 3000,
    status: "Produção",
    faltante: 100,
    atraso: 90,
    tempoEstado: "00:00",
    motivoParada: "Injustificada",
    historicoOEE: [90, 70, 77, 89, 71, 89, 83],
    dataHistoricoOEE: [
      "23/04",
      "24/04",
      "25/04",
      "26/04",
      "27/04",
      "28/04",
      "29/04"
    ],
    dateAtual: "10:00",
    indice: 7
  },
  {
    ordem: "O12AC1SA",
    peca: "P10012",
    codigo: "F03",
    descricao: "Fresadora03",
    oee: 91,
    desempenho: 90,
    disponibilidade: 83,
    qualidade: 92,
    progress: 0,
    total: 3000,
    status: "Ocioso",
    faltante: 3000,
    atraso: -100,
    tempoEstado: "00:05",
    motivoParada: "Almoço",
    historicoOEE: [90, 88, 78, 90, 91, 87, 91],
    dataHistoricoOEE: [
      "23/04",
      "24/04",
      "25/04",
      "26/04",
      "27/04",
      "28/04",
      "29/04"
    ],
    dateAtual: "10:00",
    indice: 8
  },
  {
    ordem: "O12AAB",
    peca: "P1CB31",
    codigo: "C01",
    descricao: "Prensa01",
    oee: 93,
    desempenho: 90,
    disponibilidade: 80,
    qualidade: 99,
    progress: 2000,
    total: 4500,
    status: "Produção",
    faltante: 2500,
    atraso: 100,
    tempoEstado: "00:35",
    motivoParada: "Manutenção Corretiva",
    historicoOEE: [90, 91, 86, 78, 79, 81, 88],
    dataHistoricoOEE: [
      "23/04",
      "24/04",
      "25/04",
      "26/04",
      "27/04",
      "28/04",
      "29/04"
    ],
    dateAtual: "10:00",
    indice: 9
  },
  {
    ordem: "O145CCC",
    peca: "P1D92G",
    codigo: "C02",
    descricao: "Prensa02",
    oee: 80,
    desempenho: 100,
    disponibilidade: 87,
    qualidade: 88,
    progress: 2400,
    total: 2700,
    status: "Setup",
    faltante: 300,
    atraso: 20,
    tempoEstado: "02:20",
    motivoParada: "Almoço",
    historicoOEE: [80, 85, 86, 90, 79, 88, 95],
    dataHistoricoOEE: [
      "23/04",
      "24/04",
      "25/04",
      "26/04",
      "27/04",
      "28/04",
      "29/04"
    ],
    dateAtual: "10:00",
    indice: 10
  },
  {
    ordem: "O191AC",
    peca: "P9C99",
    codigo: "F04",
    descricao: "Fresadora04",
    oee: 85,
    desempenho: 90,
    disponibilidade: 82,
    qualidade: 85,
    progress: 260,
    total: 3000,
    status: "Parada",
    faltante: 100,
    atraso: -200,
    tempoEstado: "04:20",
    motivoParada: "Injustificada",
    historicoOEE: [90, 70, 77, 89, 71, 89, 83],
    dataHistoricoOEE: [
      "23/04",
      "24/04",
      "25/04",
      "26/04",
      "27/04",
      "28/04",
      "29/04"
    ],
    dateAtual: "10:00",
    indice: 11
  },
  {
    ordem: "O13AC1SB",
    peca: "P10A12",
    codigo: "R04",
    descricao: "Injetora04",
    oee: 91,
    desempenho: 90,
    disponibilidade: 79,
    qualidade: 90,
    progress: 100,
    total: 3000,
    status: "Ocioso",
    faltante: 2900,
    atraso: -50,
    tempoEstado: "00:15",
    motivoParada: "Manutenção Corretiva",
    historicoOEE: [90, 88, 78, 90, 91, 87, 91],
    dataHistoricoOEE: [
      "23/04",
      "24/04",
      "25/04",
      "26/04",
      "27/04",
      "28/04",
      "29/04"
    ],
    dateAtual: "10:00",
    indice: 12
  }
];

export default data;
